// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:580px){.profile .active a{font-weight:600;border-bottom:2px solid #9dba48;padding-left:0!important}}@media (max-width:579px){.profile li{margin:8px -12px;padding:12px 20px}}@media (min-width:768px){.profile .active{padding-left:18px!important;font-weight:600;border-left:2px solid #9dba48}.profile .active,.profile .active a{border-bottom:0 solid #9dba48}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
